import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const fmtQty = (n) => (n == null ? "0" : Number(n).toLocaleString("cs-CZ", { maximumFractionDigits: 3 }));

// Inventura (§7) — napočítané množství vs. systém, živý rozdíl. Manko jde do režie.
export function InventoryDialog({ warehouse, stock, busy, onSubmit, onClose }) {
  const [counts, setCounts] = useState(() => (stock || []).map((it) => ({ id: it.id, name: it.name, unit: it.unit, system: it.qty, counted: it.qty })));
  const setCounted = (id, v) => setCounts((cs) => cs.map((c) => (c.id === id ? { ...c, counted: v } : c)));
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-[620px] max-h-[85vh] overflow-y-auto" data-testid="inventory-dialog">
        <DialogHeader><DialogTitle>Inventura — {warehouse?.name}</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">Zadejte skutečně napočítané množství. Rozdíl se zaznamená jako pohyb „Inventura"; manko jde do režie firmy.</p>
        <div className="max-h-[44vh] overflow-y-auto divide-y divide-border border border-border rounded-[14px] mt-2" data-testid="inventory-rows">
          {counts.map((c) => {
            const diff = (Number(c.counted) || 0) - (c.system || 0);
            return (
              <div key={c.id} className="flex items-center justify-between gap-3 px-3 py-2.5" data-testid={`inventory-row-${c.id}`}>
                <div className="min-w-0">
                  <div className="font-semibold truncate">{c.name}</div>
                  <div className="text-xs text-muted-foreground">
                    systém {fmtQty(c.system)} {c.unit}
                    {Math.abs(diff) > 0.0001 && <span className={diff < 0 ? "text-rose-500" : "text-emerald-500"}> · {diff > 0 ? "+" : ""}{fmtQty(diff)} {c.unit}</span>}
                  </div>
                </div>
                <Input type="number" step="0.001" value={c.counted} onChange={(e) => setCounted(c.id, e.target.value)}
                  className="h-10 w-28 shrink-0" data-testid={`inventory-count-${c.id}`} />
              </div>
            );
          })}
          {counts.length === 0 && <div className="p-4 text-center text-sm text-muted-foreground">Sklad je prázdný.</div>}
        </div>
        <DialogFooter>
          <Button variant="outline" className="w-full md:w-auto" onClick={onClose}>Zrušit</Button>
          <Button className="w-full md:w-auto" disabled={busy || counts.length === 0}
            onClick={() => onSubmit({ counts: counts.map((c) => ({ stock_item_id: c.id, counted_qty: Number(c.counted) })) })}
            data-testid="inventory-confirm">
            {busy ? "Ukládám…" : "Uložit inventuru"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
